export var SurveyLogicExpressionNode;
(function (SurveyLogicExpressionNode) {
    SurveyLogicExpressionNode["OpeningParenthesis"] = "opening-paren";
    SurveyLogicExpressionNode["ClosingParenthesis"] = "closing-paren";
    SurveyLogicExpressionNode["LogicalOperator"] = "logical-operator";
    SurveyLogicExpressionNode["Condition"] = "condition";
})(SurveyLogicExpressionNode || (SurveyLogicExpressionNode = {}));
